import { useCallback } from 'react';
import { Option } from 'effect';
import { log } from '../lib/logger';
import { useForceCloseConversation } from './useForceCloseConversation';
import { setErrorStateThrottled, useErrorState, } from '../stores/errorStateStore';
import { useShowChatboxStore } from '../stores/showChatboxStore';
import { useLineOfBusiness } from './useLineOfBusiness';
import { useEventStore } from '../stores/eventStore';
import { useConversationClosed, useConversationRestarted, } from '../stores/conversationStateStore';
import { useCloseConfirmationDialogStore } from '../stores/closeConfirmationDialogStore';
import { useNotificationsStore } from '../stores/notificationsStore';
export const useCloseChat = () => {
    const forceCloseConversation = useForceCloseConversation();
    const { errorState } = useErrorState();
    const { lineOfBusiness } = useLineOfBusiness();
    const [, setShowChatbox] = useShowChatboxStore(lineOfBusiness);
    const { setEvents } = useEventStore();
    const { hasClosed, setHasClosed } = useConversationClosed();
    const { setHasRestarted } = useConversationRestarted();
    const { setIsOpen: setConfirmationDialog } = useCloseConfirmationDialogStore();
    const { setNotificationsCount } = useNotificationsStore();
    const handleCloseClick = useCallback(() => {
        const cleanup = () => {
            setEvents([]);
            setHasClosed(false);
            setHasRestarted(false);
            setShowChatbox(false);
            setNotificationsCount(0);
            setErrorStateThrottled(undefined);
        };
        if (Option.isSome(errorState)) {
            cleanup();
        }
        else if (hasClosed) {
            forceCloseConversation().catch(log.error);
            cleanup();
        }
        else {
            setConfirmationDialog(true);
        }
    }, [
        errorState,
        forceCloseConversation,
        hasClosed,
        setConfirmationDialog,
        setEvents,
        setHasClosed,
        setHasRestarted,
        setNotificationsCount,
        setShowChatbox,
    ]);
    return { handleCloseClick };
};
